import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Ascoltaci from "./pages/Ascoltaci";
import ChiSiamo from "./pages/ChiSiamo";
import Palinsesto from "./pages/Palinsesto";
import Podcast from "./pages/Podcast";
import Contatti from "./pages/Contatti";
import Drive from "./pages/Drive";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminScaletta from "./pages/AdminScaletta";
import ScalettaShared from "./pages/ScalettaShared";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";

// Layout component that conditionally shows Header/Footer
const Layout = ({ children }) => {
  const location = useLocation();
  // Admin and the shared (read-only) Scaletta are standalone tools — no public
  // site chrome.
  const bare = location.pathname.startsWith('/admin') || location.pathname.startsWith('/scaletta/');

  return (
    <>
      {!bare && <Header />}
      {children}
      {!bare && <Footer />}
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <div className="App">
          <Layout>
            <Routes>
              {/* Italian (canonical, at the root) */}
              <Route path="/" element={<Home />} />
              <Route path="/ascoltaci" element={<Ascoltaci />} />
              <Route path="/chi-siamo" element={<ChiSiamo />} />
              <Route path="/palinsesto" element={<Palinsesto />} />
              <Route path="/podcast" element={<Podcast />} />
              <Route path="/contatti" element={<Contatti />} />
              {/* Drive show promo — English-only page, same content on both paths */}
              <Route path="/drive" element={<Drive />} />
              {/* English (prefixed with /en) */}
              <Route path="/en" element={<Home />} />
              <Route path="/en/ascoltaci" element={<Ascoltaci />} />
              <Route path="/en/chi-siamo" element={<ChiSiamo />} />
              <Route path="/en/palinsesto" element={<Palinsesto />} />
              <Route path="/en/podcast" element={<Podcast />} />
              <Route path="/en/contatti" element={<Contatti />} />
              <Route path="/en/drive" element={<Drive />} />
              {/* Admin */}
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/scaletta" element={<AdminScaletta />} />
              {/* Token-gated read-only rundown (shareable link) */}
              <Route path="/scaletta/shared/:token" element={<ScalettaShared />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          <Toaster />
        </div>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
